export default [
  {
    title: 'My Ads',
    icon: 'FileIcon',
    route: 'my-ads',
  },
  {
    title: 'Brands',
    icon: 'AwardIcon',
    route: 'brands',
  },
  {
    title: 'Reports',
    icon: 'BarChart2Icon',
    route: 'reports',
  },
  {
    title: 'Billing',
    icon: 'CreditCardIcon',
    route: 'Plan-Renewal',
  },
  {
    title: 'FAQ',
    icon: 'HelpCircleIcon',
    route: 'pages-faq',
  },
  {
    title: 'Help',
    icon: 'InfoIcon',
    route: 'pages-help',
  },
]
